import axios from 'axios'
import { EventTypes, emitEvent } from '../util/event'
import { getGuid, getReqId, trimStringField } from '../util'
import { toCbpDate } from '../util/date'
import { Message } from 'element-ui'
import aes from './crypto'
import { BaseURL, CBPBaseURL, API_ENV, client_secret, Platform } from '@/config'
// required for aes-gcm
axios.defaults.headers.common['X-Encrypt-Version'] = 'AES-GCM-V1'

let timeout = 600000
let getAuthDataFun
export function setGetAuthDataFun(fn) {
  getAuthDataFun = fn
}
let errorFlag = 0
export async function apiDataDecrypt({ res, showError, secret, rawData }) {
  if (res.data instanceof Blob) {
    return res.data
  }
  let data
  if (res.data && typeof res.data.data === 'string') {
    let dataStr = await aes.decrypt(res.data.data, secret)
    try {
      data = JSON.parse(dataStr)
      if (API_ENV !== 'production') {
        console.log('-----------------')
        let srvcCd = data?.header?.srvcCd
        if (srvcCd) {
          console.log('Response srvcCd: ', srvcCd, '\nResponse data:', data)
        } else {
          console.log(
            'Response url: ',
            res.config?.url,
            '\nResponse data:',
            data
          )
        }
      }
      if ('header' in data) {
        if (
          data.header.returnCode !== '0' &&
          // 需要确认审批的结果 不需要报错
          !data.header.data?.aprvlId
        ) {
          let msg = data.header.errorMessages || []
          msg = msg[msg.length - 1] || {}
          msg = msg.message || msg.detailMessage
          if (showError) {
            Message.error(msg || 'Netwrok Error')
          }
        }
        return data
      }
      if ('code' in data) {
        if (data.code !== '0000' && data.code != '0') {
          let msg = data.msg || 'Netwrok Error'
          if (data.code === 'WARNING') {
            // 新需求：有的不是报错 是提示用warning
            if (showError) {
              Message.warning(msg)
            }
          } else {
            if (showError) {
              Message.error(msg)
            }
          }
          // if (data.code === '401') {
          //   // 退出重新登录
          //   emitEvent(LOGOUT_EVENT, data)
          // }
          return rawData ? data : ''
        }

        if ((data.code === '0000' || data.code === '0') && !data.data) {
          data.data = {}
        }
        return rawData ? data : data.data
      }
      return data
    } catch (e) {
      console.warn('parse json response error', e)
    }
  }
  if (res.data?.code === '2') {
    emitEvent(EventTypes.LOGOUT_EVENT, {
      code: '401',
      msg: 'Login Status Expired'
    })
    // onLogout(expires_time! > Date.now() ? 'LoginFromOther' : 'Expired')
  } else if (res.data?.code) {
    // gateway 系统维护中
    if (errorFlag > 0) return false
    errorFlag++
    Message.error({
      message: res.data.msg || 'System is maintaining',
      duration: 3000
    })
    setTimeout(() => {
      errorFlag = 0
    }, 3000)
  }
  return false
}

async function request({
  method,
  url,
  data,
  params,
  onUploadProgress,
  onDownloadProgress,
  responseType,
  // 返回原始 {code:x,data:xx,msg: xxx} 格式
  rawData = false,
  headers = {},
  showError = true
}) {
  let options = {
    url: url,
    method: method,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...headers
    },
    params,
    onUploadProgress,
    onDownloadProgress,
    responseType: responseType,
    timeout: timeout
  }
  let access_token = null
  let secret = client_secret
  if (getAuthDataFun) {
    let [a, s] = await getAuthDataFun()
    access_token = a
    secret = s || client_secret
  }
  if (access_token) {
    options.headers['Authorization'] = 'Bearer ' + access_token
  }
  if (API_ENV !== 'production') {
    console.log('-----------------')
    let srvcCd = data?.header?.srvcCd
    if (srvcCd) {
      console.log('Request srvcCd: ', srvcCd, '\nRequest data:', data)
    } else {
      console.log('Request url: ', url, '\nRequest data:', data)
    }
  }
  options.data = JSON.stringify({
    reqId: getReqId(cbbheader.custId || cbbheader.staffId),
    data: await aes.encrypt(trimStringField(data) || {}, secret)
  })

  return axios(options)
    .then(res =>
      apiDataDecrypt({ res, showError, secret, reqData: data, rawData })
    )
    .catch(error => {
      console.log(error)
      let msg = error.message || 'Network timeout'
      if (error.request) {
        // 500 最高级提示
        if (error.request.status >= 500) {
          msg = 'System error'
        }
        // 登录超时
        if (error.request.status === 401) {
          emitEvent(EventTypes.LOGOUT_EVENT, { code: '401', msg: msg })
          return false
        }
      }
      if (showError) {
        Message.error(msg)
      }
      return false
    })
}
/**
 * operation 30
 * teller 01
 * mportal 03
 */
const DefaultChnlDscd = Platform === 'merchant' ? '03' : '30'

const cbbheader = {
  instCd: '205',
  userGrpCd: '02',
  tmZone: '',
  custRprsnId: '',
  deptId: '001',
  chnlDscd: DefaultChnlDscd,
  custId: '',
  staffId: ''
}

export function setCbbHeader(header = {}) {
  cbbheader.instCd = header.instCd || '205'
  cbbheader.deptId = header.deptId || '001'
  cbbheader.custId = header.custId || ''
  cbbheader.staffId = header.staffId || ''
  cbbheader.chnlDscd = header.chnlDscd || DefaultChnlDscd
  cbbheader.userGrpCd = header.userGrpCd || '02'
  cbbheader.custRprsnId = header.custRprsnId || ''
}

export default {
  /**
   * 请求cbb接口
   * @param {*} srvcCd 接口code
   * @param {*} data  接口参数 （不含header）
   * @param {*} options  request api参数
   * @returns
   */
  requestCBB(srvcCd, data, options = {}) {
    let cbbData = {
      header: {},
      ...data
    }
    cbbData.header = {
      ...cbbheader,
      ...cbbData.header,
      srvcCd: srvcCd,
      lngCd: localStorage.lang || 'en',
      txDt: toCbpDate(new Date()),
      guid: getGuid()
    }
    return request({
      method: 'post',
      url: CBPBaseURL,
      data: cbbData,
      ...options
    })
  },
  get(config) {
    let url = BaseURL + config.url
    return request({
      method: 'get',
      ...config,
      url
    })
  },
  /**
   * post 请求
   * @param {{url: string, data?: any, params?: any, rawData?: boolean, headers?: any, showError?: boolean, responseType?: string}} config request api参数
   * @returns {Promise<any>}
   */
  post(config) {
    let url = config.url || ''
    if (url[0] === '/') {
      url = url.substring(1)
    }
    url = BaseURL + url
    return request({
      method: 'post',
      ...config,
      url
    })
  },
  put(config) {
    let url = config.url || ''
    if (url[0] === '/') {
      url = url.substring(1)
    }
    url = BaseURL + url
    return request({
      method: 'put',
      ...config,
      url
    })
  },
  patch(config) {
    let url = config.url || ''
    if (url[0] === '/') {
      url = url.substring(1)
    }
    url = BaseURL + url
    return request({
      method: 'patch',
      ...config,
      url
    })
  },
  delete(config) {
    let url = config.url || ''
    if (url[0] === '/') {
      url = url.substring(1)
    }
    url = BaseURL + url
    return request({
      method: 'delete',
      ...config,
      url
    })
  },
  request
}
